<div class="wizard">
  <div class="wizard-header">
    <ul class="breadcrumb-container" *ngIf="config.showSteps">
      <li *ngFor="let step of steps; let i = index" (click)="goToStep(step)" class="breadcrumb-item">
        <div class="steps" [ngClass]="{ active: step.isActive, disabled: step.isDisabled, done: step.isDone }">
          <span class="step-number">{{ i + 1 }}</span>
          <span class="step-text center-smallcontainer">{{ step.title }}</span>
          <span *ngIf="step.isDone" class="glicon-check-circle"></span>
        </div>
      </li>
    </ul>
  </div>
  <div class="wizard-block">
    <ng-content></ng-content>
  </div>
  <div class="wizard-footer" *ngIf="config.showFooter" [attr.hidden]="isDone ? true : null">
    <ng-content select="[wizard-actions]"></ng-content>
    <gl-button
      color-secondary
      [text]="activeStep.previousButton | translate"
      (onClick)="previous()"
      *ngIf="hasPrevStep && activeStep?.showPrev"
    >
    </gl-button>
    <gl-button
      color-primary
      [text]="activeStep.nextButton | translate"
      class="right"
      (onClick)="next()"
      [disabled]="!activeStep.isValid"
      *ngIf="hasNextStep && activeStep?.showNext"
    >
    </gl-button>
    <gl-button
      color-primary
      class="right"
      [text]="activeStep.doneButton | translate"
      (onClick)="done()"
      [disabled]="!activeStep.isValid"
      *ngIf="!hasNextStep && activeStep?.showDone"
    >
    </gl-button>
  </div>
</div>
